import React from 'react';
import {
  Select as BaseSelect,
  FormControl,
  InputLabel,
  MenuItem,
} from '@material-ui/core';
import PropTypes from 'prop-types';

const Select = (props) => {
  const { items, ...formControlProps } = props;
  return (
    <FormControl variant="outlined" {...formControlProps}>
      <InputLabel>{props.label}</InputLabel>
      <BaseSelect label={props.label} {...formControlProps}>
        {items.map((item) => {
          return (
            <MenuItem key={item.id} value={item.id}>
              {item.label}
            </MenuItem>
          );
        })}
      </BaseSelect>
    </FormControl>
  );
};

Select.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.node,
  value: PropTypes.any,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
    })
  ),
};

export default Select;
